import PageContent from './PageContent.js';

export default PageContent;
